
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class SidingTrackParkingBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class SidingTrackParkingBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:      string = data._id.match(/^siding-track-park-(.*)/i)[1];
    const depDir: string = data.r ? 'REV' : 'FWD';
    const dir:    string = data.dd;

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `${depDir} Parking [SIDING] ${data.l.n} ${dir}...`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'siding-track-park',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      direction:       data.dd,
      kind:            data.l.k,
      sIndex:          data.l.sx,
      index:           data.l.ix,
      u:               data._id
    };

  }
}
